import { useState } from '@/runtime';
export type VariantName = 'A' | 'B';
const STORAGE_KEY = 'ff-variant';

export function currentVariant(): VariantName {
  if (typeof window === 'undefined' || typeof localStorage === 'undefined') return 'A';
  return localStorage.getItem(STORAGE_KEY) === 'B' ? 'B' : 'A';
}

export function applyVariant(name: VariantName) {
  document.documentElement.dataset.variant = name;
  try { localStorage.setItem(STORAGE_KEY, name); } catch { /* приватный режим: вариант живёт до перезагрузки */ }
}

export function useVariant() {
  const variant = useState<VariantName>('variant', () => 'A');
  function sync() { variant.value = document.documentElement.dataset.variant === 'B' ? 'B' : 'A'; }
  function toggle() { applyVariant(variant.value === 'B' ? 'A' : 'B'); sync(); }
  return { variant, sync, toggle };
}
